import { useSelector } from "react-redux";

import { FreezeOnExit } from "@src/components/animation/FreezeOnExit";
import { ImagePanel } from "@src/features/experienceBuilder/modifications/basicMods/ImagePanel";
import { LayoutPanel } from "@src/features/experienceBuilder/modifications/basicMods/LayoutPanel";
import { InjectionPanel } from "@src/features/experienceBuilder/modifications/basicMods/InjectionPanel";
import { TextPanel } from "@src/features/experienceBuilder/modifications/basicMods/TextPanel";
import { ExperienceBuilderSelector } from "@src/store/slices/experienceBuilder";

export function useBasicModPanels() {
  const draft = useSelector(
    ExperienceBuilderSelector.basicMod.getVariationDraft
  );

  return [
    draft && (
      <FreezeOnExit key="basicMod-panel">
        {draft.type === "text" && <TextPanel />}
        {draft.type === "image" && <ImagePanel />}
        {draft.type === "layout" && <LayoutPanel />}
        {draft.type === "injection" && <InjectionPanel />}
      </FreezeOnExit>
    ),
  ];
}
